import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-moving-items-section',
  templateUrl: './moving-items-section.component.html',
  styleUrls: ['./moving-items-section.component.scss'],
  imports: [CommonModule , CardModule, TagModule, ProgressSpinnerModule]
})
export class MovingItemsSectionComponent {
  @Input() fastMovingItems: any[] = [];
  @Input() slowMovingItems: any[] = [];
  @Input() errorMsg: string = '';
}